<template>
  <div class="d-flex justify-content-between justify-content-sm-start align-items-center">
    <h3 class="m-0 mr-2 month">{{ calendarForDay.monthLong }} {{ calendarForDay.year }}</h3>
    <button-action i18nMessage="common.monthPrev" :prevM=true v-on:clicked="monthPrev()" class="btn-calendar dis" :btnDisabled="!showBackButton()" />
    <button-action i18nMessage="common.monthNext" :nextM=true v-on:clicked="monthNext()" class="btn-calendar" />
    <button-action i18nMessage="common.monthCurrent" v-on:clicked="monthCurrent()" class="btn-calendar d-none d-sm-block" />
  </div>
</template>

<script lang="ts">
import ButtonAction from '@/components/interaction/ButtonAction.vue';
import config from '@/config/config';
import LoadingMixin from '@/mixins/LoadingMixin';
import { GuiOptions } from '@/models/GuiOptions';
import { now } from '@/utils/dateTimeUtils';
import { DateTime } from 'luxon';
import { defineComponent, PropType } from 'vue';


export default defineComponent({
  name: 'CalendarMonthSelector',
  mixins: [
    LoadingMixin
  ],
  props: {
    calendarForDay: {
      type: Object as PropType<DateTime>,
      required: true
    }
  },
  components: {
    ButtonAction
  },
  methods: {
    showBackButton(){
      return this.calendarForDay >= now() || config.interface !== GuiOptions.user
    },
    monthPrev() {
      this.$emit('changed', this.calendarForDay.minus({
        months: 1
      }))
    },
    monthNext() {
      this.$emit('changed', this.calendarForDay.plus({
        months: 1
      }))
    },
    monthCurrent() {
      this.$emit('changed', now())
    },
  }
});
</script>
<style scoped>
.month{
  min-width: 170px;
}
</style>
